<template>
    <div class="papsi-wrapper flex justify-between">
        <div>
            <h1 class="text-2xl font-semibold text-[#24723b]">Employee Search & Modification</h1>
            <p class="text-xs text-[#747474] mt-2">Home / Employee Page / Profile / Search</p>
        </div>
         <!-- <div>
            <button  class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3" @click="addEmployee = true, type = 'Add'" >+ ADD NEW EMPLOYEE </button>
        </div> -->
    </div>
    <div class="mt-11"> 
        <div class="flex w-full gap-3 mb-5">
            <input type="text"  @input="isTyping = true, search = search.toUpperCase()" placeholder="Search" class=" w-[500px]   border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
            <select class="w-[150px]  border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold outline-none" @change="filteredOptions" v-model="division_active" >
                <option value="" selected disabled>Select Division</option>
                <option value="ALL" >ALL</option>
                <option v-for="(info,index) in $store.state.divisionList" :key="index" :value="info.division_code">{{ info.Abbreviation }}</option>
            </select>
        </div>
        <div class=" bg-[#f0f0f0] border-[#ffffff41] border-[3px]  rounded-md  ">
            <div class=" ">
                <div v-if="loading" class="absolute  bg-[#b6b5b542] w-full h-full flex justify-center items-center z-0" >
                    <span class="loader z-50"></span>
                </div>
                <div class="p-3">
                    <TrainingReq :Action="true" :header="header" :info="filteredDetails" :column="column" :VButton="true" :DButton="false" :EButton="false" @ViewButton="test" />
                </div>
            </div>
        </div>
    </div>
        <div class="" v-if="EmpModal">
            <EmployeeModal @CloseView="EmpModal = false" :fpk="fpk" @addEmployment="openEmployment" @addDependent="dependent = true"  @displayPrompt="displayPrompt" @removeDependent="removeDependent" ref="refresh"/>
        </div>
    <div>
    </div>
    <div v-if="addEmployee">
        <div @click="addEmployee = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">ADD NEW EMPLOYEE</p>
                </div>
                <div class="pafcpic_body py-4 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Last name*</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Last Name" v-model="lname">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">First name*</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"  placeholder="Enter First Name" v-model="fname">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Middle name</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"  placeholder="Enter Middle Name" v-model="mname">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="addNewEmployee">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="closeAddEmployee">Cancel</button>
            </div>
        </div>
    </div>
</div>

<ValidationModal v-if="validationModal" @close="this.validationModal = false"  :header="valHeader" :header1="valHeader1" :success="false"/> 

<PromptComponent class=" z-50" v-if="prompt" :header="promptheader" :header1="promptheader1" :success="success" @close="prompt = false"/>

<div v-if="Validation">
    <Prompt @CloseSignatory="Validation = false" type="VALIDATION"/>
</div>

<div v-if="enabledEmployment" class="z-10">
    <Employment  @outsideEmploytment="outsideEmploytment" @insideEmploytment="addInsideCompany" :disabledbtn="disabledbtn" @close="enabledEmployment = false"/>
</div>

<div v-if="dependent" class="z-10">
    <Dependent @close="dependent = false" @addDependent="addDependent"/>
</div>

<div v-if="succesDependent">
    <Prompt @CloseSignatory="succesDependent = false" type="DEPENDENT"/>
</div>

<div v-if="deleteDependent">
    <Prompt @CloseSignatory="deleteDependent = false" type="DELETE"/>
</div>

<div v-if="addNewEmp">
    <Prompt @CloseSignatory="addNewEmp = false" type="ADDNEWEMP"/>
</div>

</template>
<script>
import _ from 'lodash';
import { defineComponent } from 'vue'
import Services            from '../../../services/admin'
import Dep            from '../../../services/dependent'
import Employ            from '../../../services/employment'
import TrainingReq         from '../TableControl/TableControl.vue'
import EmployeeModal       from '../modal/EmployeeModal.vue'
import Prompt              from '../../controls/Prompt/RequestPromt.vue'
import Dependent           from '../modal/AddDependentModal.vue'
import Employment          from '../modal/ServiceRecordModal.vue'
import ValidationModal     from '../../controls/Prompt/ValidationModal.vue'
import PromptComponent from "@/componentsv1/Prompt/PromptComponent.vue";

export default defineComponent( {
    components:{
        TrainingReq,
        EmployeeModal,
        Prompt,
        Dependent,
        ValidationModal,
        Employment,
        PromptComponent
    },
    data(){
        return{
            disabledbtn:false,
            prompt: false,
            promptheader: null,
            promptheader1: null,
            success:false,
            enabledEmployment:false,
            validationModal:false,
            valHeader:"",
            valHeader1:"",
            fname:"",
            lname:"",
            mname:"",
            employeeDetails: null,
            filteredDetails:false,
            addNewEmp: false,
            isTyping: false,
            deleteDependent: false,
            succesDependent: false,
            dependent:       false,
            loading:        false,
            Validation:     false,
            addEmployee:    false,
            EmpModal:       false,
            division_active: 'ALL',
            fpk:            null,
            search:         '',
            header:[
                {
                    id: 1,
                    label: 'No.',
                    title: 'No.',
                    visible: true
                },
                {
                    id: 2,
                    label: 'Employee ID',
                    title: 'Employee ID',
                    visible: true
                },
                {
                    id: 3,
                    label: 'Full Name',
                    title: 'Name',
                    visible: true
                },
                {
                    id: 3,
                    label: 'Position',
                    title: 'Position',
                    visible: true
                },
                {
                    id: 3,
                    label: 'Position',
                    title: 'Division',
                    visible: true
                },
                {
                    id: 4,
                    label: 'Request Date',
                    title: 'Action',
                    visible: true
                }
            ],
            column:[
                'index',
                'emp_key',
                'full_name',
                'position',
                'div_id',
            ]
        }
    },
    watch: {
        search: _.debounce(function() {
            this.isTyping = false;
        }, 700),
        isTyping: function(value) {
            if (!value) {
                this.filteredOptions()
            }
        }
    },
    mounted(){
        this.fname = ""
        this.getEmployeeName()
    },
    computed:
    {
      
    },
    methods:{
        displayPrompt(header,header1){
            this.valHeader = header
            this.valHeader1 = header1
            this.validationModal = true
        },
        closeAddEmployee(){
            this.fname = ""
            this.mname = ""
            this.lname = ""
            this.addEmployee = false
        },
        test(row){
            this.$emit("showLoader")
            this.fpk = row.emp_key,
            this.EmpModal = true
            this.$emit("hideLoader")
        },
        openEmployment(){
            this.enabledEmployment = true;
        },
        async filteredOptions() {
            this.loading = true
            if(this.division_active != "ALL"){
                this.filteredDetails =   this.employeeDetails.filter(
                details => 
                details.full_name && details.full_name.toLowerCase().includes(this.search.toLowerCase()) &&
                details.div_id && details.div_id.toLowerCase().includes(this.division_active.toLowerCase())       
                ).splice(0, 20)
            }
            else{
                this.filteredDetails =   this.employeeDetails.filter(
                details => 
                details.full_name && details.full_name.toLowerCase().includes(this.search.toLowerCase())).splice(0, 20)
            }
            this.loading = false
        },
 
        async getEmployeeName(){
            this.$emit("showLoader")

            if(this.$store.state.position_key  == null){
                const success1 = await Services.getPositionkey()
                this.$store.state.position_key = success1.data
            }

            const success =  await Services.getEmployeeDetailsWithPosition()
            this.employeeDetails =  success.data
            this.filteredDetails =  success.data
            this.$emit("hideLoader")
        },
        async addNewEmployee(){
            this.$emit('showLoader')
            if(!this.fname || !this.lname){
                this.Validation = true
            }
            else{
                const success = await Services.addNewEmployee(this.fname,this.mname,this.lname)
                this.$emit('hideLoader')
                if(success.success == true){
                    this.addEmployee = false
                    this.addNewEmp   = true
                    await this.closeAddEmployee()
                    this.$emit('hideLoader')
                }
                else{
                    this.Validation = true
                }
            }
            this.$emit('hideLoader')
        },
        async outsideEmploytment(company_name,position,start_date,end_date){
            this.$emit('showLoader')
            let that = this
            await Employ.addOutsideCompany(this.fpk,company_name,position,start_date,end_date).then(async function(){
                that.enabledEmployment = false
                await that.$refs.refresh.getHistory()
                that.success       = true
                that.promptheader  = "Successsfully Added Employment History"
                that.promptheader1 = "To modify the Employment History, go to the Employment Module."
                that.prompt        =  true
            }).catch(function(error){
                that.success       = false
                that.promptheader  = "Error"
                that.promptheader1 = error.response.data.message
                that.prompt        =  true
                //console.log(error.response.data.message)
            });
            this.$emit('hideLoader')
        },
        async addInsideCompany(division,department,section,position,start_date,end_date){
            this.$emit('showLoader')
            let that = this
            await Employ.addInsideCompany(this.fpk,division,department,section,position,start_date,end_date).then(async function(){
                that.enabledEmployment = false
                await that.$refs.refresh.getHistory()
                that.success       = true
                that.promptheader  = "Successsfully Added Employment History"
                that.promptheader1 = "To modify the Employment History, go to the Employment Module."
                that.prompt        =  true
            }).catch(function(error){
                that.success       = false
                that.promptheader  = "Error"
                that.promptheader1 = error.response.data.message
                that.prompt        =  true
                //console.log(error.response.data.message)
            });
            this.$emit('hideLoader')
        },
        async addDependent(fname, lname , mname, aname, birthdate, contact_no, relation){
            this.$refs.refresh.showLoader()
            this.$emit('showLoader')
            this.disabledbtn = true
            let that = this
            await Dep.createDependent(fname, lname, mname, aname, birthdate, contact_no, relation, this.fpk).then(function(){
                that.dependent = false
                that.$refs.refresh.refreshDependent()
                that.success       = true
                that.promptheader  = "Successfully Added New Dependent"
                that.promptheader1 = "To check the updated list of dependents, go to the employee profile module."
                that.prompt        =  true
            }).catch(function(error){
                that.success       = false
                that.promptheader  = "Error"
                that.promptheader1 = error.response.data.message
                that.prompt        =  true
            });
            this.disabledbtn = false
            this.$refs.refresh.hideLoader()
            this.$emit('hideLoader')
        },
            async removeDependent(id){
                this.$refs.refresh.showLoader()
                const success = await Services.deleteDependent(id)
                if(success.success == true){
                    this.$refs.refresh.refreshDependent()
                    this.$refs.refresh.hideLoader()
                    this.deleteDependent = true  
                }
                else{
                    this.$refs.refresh.hideLoader()    
                }  
            }
        }
    })    
    </script>
<style scoped>
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 

</style>

    